import type { RootState } from "~/store";

import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export const DEFAULT_GRID_TOTALS_KEY = "default";

interface GridTotalRows {
	gridId: string;
	total: number;
}

interface AggridState {
	totalRows: Record<string, number>;
}

const initialState: AggridState = {
	totalRows: {}
};

export const aggridSlice = createSlice({
	initialState,
	name: "aggrid",
	reducers: {
		clearTotalRows: (state, action: PayloadAction<string>) => {
			delete state.totalRows[action.payload];
		},
		setGridTotalRows: (state, action: PayloadAction<GridTotalRows>) => {
			state.totalRows[action.payload.gridId] = action.payload.total;
		},
		setTotalRows: (state, action: PayloadAction<number>) => {
			state.totalRows[DEFAULT_GRID_TOTALS_KEY] = action.payload;
		}
	}
});

export const { clearTotalRows, setGridTotalRows, setTotalRows } = aggridSlice.actions;

export const selectTotalRows =
	(gridId?: string) =>
	(state: RootState): number =>
		state.aggrid.totalRows[gridId ?? DEFAULT_GRID_TOTALS_KEY] ?? 0;

export default aggridSlice.reducer;
